import Moment from "moment-timezone";

import {
  formatCurrencyData,
  formatDateToFinanceDate,
  formatTextData
} from "../utils/misc";

// Filter report data
export const filterReportData = (reportData, reportFields) => {
  const blankFields = ["created", "completed_at"];
  const textFields = ["mall_name", "legal_name", "brand_name"];
  const currencyFields = [
    "total_retail_price",
    "sale_discount_tenant",
    "sale_discount_sm",
    "sale_discount_total",
    "subtotal",
    "shipping_cost",
    "total_gross_transaction",
    "voucher_discount_tenant",
    "voucher_discount_sm",
    "discount_amount",
    "price_paid",
    "payment_fee",
    "payment_fee_vat",
    "payment_fee_adjustment",
    "payment_fee_adjustment_vat",
    "total_payment_fee",
    "payment_fee_witholding_tax",
    "delivery_fee_adjustment",
    "credit_card_witholding_tax",
    "other_adjustment",
    "net_settlement"
  ];
  const dateFields = ["settlement_date"];

  const filteredData = reportData
    ?.map(data => ({ ...data }))
    .map(data => {
      delete data.__typename;

      // Format text data
      textFields.forEach(field => {
        data[field] = formatTextData(data?.[field], "UPC");
      });

      // Format number into 2 decimal places
      currencyFields.forEach(field => {
        data[field] = formatCurrencyData(data?.[field]);
      });

      blankFields.forEach(field => {
        data[field] = "";
      });

      dateFields.forEach(field => {
        data[field] = formatDateToFinanceDate(data?.[field]);
      });

      // Filters object to remove extra column
      const erase = Object.keys(data).filter(
        e =>
          !Object.keys(reportFields).includes(e) &&
          Object.keys(reportFields).includes("mall_code")
      );

      // Deletes here
      for (const i in erase) {
        if ({}?.hasOwnProperty.call(erase, i)) {
          delete data[`${erase[i]}`];
        }
      }
      return data;
    });

  return filteredData;
};

// Filter report data
export const filterPayablesReportData = (reportData, reportFields) => {
  const textFields = ["mall_name", "company_name", "brand_name"];

  const filteredData = reportData?.map((data: Record<string, any>) => {
    delete data.__typename;

    Object.entries(data).forEach(([key, value]) => {
      if (textFields.includes(key)) {
        data[key] = formatTextData(value, "UPC");
        return;
      }
    });

    data.settlement_date = formatDateToFinanceDate(data?.settlement_date);

    data.coverage_start_date =
      data?.coverage_start_date === null ||
      data?.coverage_start_date === undefined
        ? ""
        : Moment.tz(new Date(data?.coverage_start_date), "Asia/Manila").format(
            "MM/DD/YYYY"
          ) +
          " - " +
          Moment.tz(new Date(data?.coverage_end_date), "Asia/Manila").format(
            "MM/DD/YYYY"
          );

    data.coverage_end_date = "";

    // Filters object to remove extra column
    const erase = Object.keys(data).filter(
      e =>
        !Object.keys(reportFields).includes(e) &&
        Object.keys(reportFields).includes("mall_code")
    );

    // Deletes here
    for (const i in erase) {
      if ({}?.hasOwnProperty.call(erase, i)) {
        delete data[`${erase[i]}`];
      }
    }
    return data;
  });

  return filteredData;
};
